import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "./setup";
import Noti from "../../view/components/general/noti";
import {ROUTES} from "../../constants";
import {MedicationItemService} from "../../services/requests/medication";

const useGetMedicationItems = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getMedicationItems", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return MedicationItemService.getMedicationItemsList(params);
    },
    enabled: modalName ?? true
  });
}

const useGetMedicationFrequency = (params: any) => {
  return useQuery({
    queryKey: ["getMedicationFrequency", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return MedicationItemService.getMedicationFrequencyList(params);
    },
  });
}

const useGetMedicationDosage = (params: any) => {
  return useQuery({
    queryKey: ["getMedicationDosage", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return MedicationItemService.getMedicationDosageList(params);
    },
  });
}

const useGetMedicationBrand = (params: any, showBrand: boolean) => {
  return useQuery({
    queryKey: ["getMedicationBrand", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return MedicationItemService.getMedicationBrandList(params);
    },
    enabled: showBrand ?? true
  });
}

const useGetMedicationItem = () => {
  return useMutation({
    mutationFn: MedicationItemService.getMedicationItem,
  })
}

const useAddMedicationItem = () => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: MedicationItemService.addMedicationItem,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          navigate(ROUTES.MEDICATION.PATH);
        }
      })
    },
  })
}

const useDeleteMedicationItem = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: MedicationItemService.deleteMedicationItem,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getMedicationItems"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetMedicationItems,
  useGetMedicationFrequency,
  useGetMedicationDosage,
  useGetMedicationBrand,
  useGetMedicationItem,
  useAddMedicationItem,
  useDeleteMedicationItem,
}
